//Archivo qué almacena las peticiones a servidor

import { getData, patchData, postData, putData } from "../../api/ApiRest";
import auditoriaSet from "../../widgets/Auditoria";

export const updateActiveCompany = async (CompanyId, isActiveCompany, observacion) => {
  //Funcionalidad a terminar por parte del backend y realizar pruebas.
  if (!CompanyId) return console.error("No se envió el id de compañía");

  const result = await patchData(
    "api/Configuracion/Company/UpdateActiveCompany",
    { CompanyId, isActiveCompany, observacion }
  ).then(
    (response) => {
      //Construimos objecto para auditoría
      let objectoCompany = {
        CompanyId,
        isActiveCompany,
        observacion
      };

      ///Construimos auditoría
      auditoriaSet(objectoCompany, {}, 'C', 'Empresa', CompanyId, 'EstadoEmpresa');

      // console.log(response);
      return response;
    },
    (error) => {
      console.log(error);
      alert("Algo salio mal, por favor contacta a soporte");
      return false;
    }
  );

  return result;
};

export const recomputeGeneralPlan = async (CompanyId) => {
  const result = await putData(
    "api/Configuracion/UtilityPublic/ReorganizacionPlanes",
    { companiaId: CompanyId }
  );
  return result;
};

export const getAllCertificates = async () => {
  const result = await getData(
    "api/Configuracion/Reporte/GeneralCertificates"
  ).then(
    (response) => {
      // console.log(response);
      return response;
    },
    (error) => {
      console.log(error);
      alert("Algo salio mal, por favor contacta a soporte");
      return false;
    }
  );

  return result;
};

export const loadGeneralCompanies = async (dataBuscar) => {
  const result = await getData(
    "api/Configuracion/Company/IndexGetData",
    { Nit: dataBuscar.Nit, Descripcion: dataBuscar.Nombre },
    false
  ).then(
    (response) => {
      if (response.status !== true) {
        return alert(response.msj);
      }

      return response.companies;
    },
    (error) => {
      console.log(error);
      alert("Algo salio mal en el cargue inicial");
    }
  );

  return result;
};

export const getEmisionPlanCompany = async (CompanyId, CompanyPlanId) => {
  const result = await getData(
    "api/Configuracion/Company/getEmissionPlanCompany",
    { CompanyId, CompanyPlanId },
    true
  ).then(
    (response) => {
      if (response.status !== true) {
        return alert(response.msj);
      }

      return response;
    },
    (error) => {
      console.log(error);
      alert("Algo salio mal en el cargue inicial");
    }
  );

  return result;
};

export const getSoftwareConfigItem = async (Nit) => {
  const result = await getData(
    "api/Configuracion/Company/IndexGetData",
    { Nit },
    true
  ).then(
    (response) => {
      if (response.status !== true) {
        return alert(response.msj);
      }

      return response.companies?.[0];
    },
    (error) => {
      console.log(error);
      alert("Algo salio mal en el cargue inicial");
    }
  );

  return result;
};

export const getDetailDayFolios = async (
  CompanyId,
  mes,
  anio,
  CompanyPlanId
) => {
  const result = await getData(
    "api/Configuracion/Company/obtenerEmisionesMes",
    { CompanyId, CompanyPlanId, mes, anio },
    true
  ).then(
    (response) => {
      if (response.status !== true) {
        return alert(response.msj);
      }

      return response;
    },
    (error) => {
      console.log(error);
      alert("Algo salio mal en el cargue inicial");
    }
  );

  return result;
};

export const getDataPlanReport = (planActivo = true, todos = false) => {
  const result = getData("api/Configuracion/Reporte/GetReporteEmisionPlan", {
    planActivo,
    todos,
  }).then(
    (response) => {
      const { planesVigentes, planesProxVencer, planesVencidos } = response;
      return { planesVigentes, planesProxVencer, planesVencidos };
    },
    (error) => {
      alert("Algo salio mal en la peticion");
      console.error(error);
    }
  );
  return result;
};

export const crearPlanPersonalizadoAPI = (
  esNuevoPlanPadre = false,
  CompanyId,
  PlanId,
  FacturaFecha,
  FacturaNumero,
  FacturaPrefijo,
  FechaInicio,
  FoliosCantidad,
  Observacion,
  PagoAnual,
  ValorUnidadFolio
) => {
  const result = postData("api/Configuracion/Company/PlanPersonalizado", {
    esNuevoPlanPadre,
    CompanyId,
    PlanId,
    FacturaFecha,
    FacturaNumero,
    FacturaPrefijo,
    FechaInicio,
    FoliosCantidad,
    Observacion,
    PagoAnual,
    ValorUnidadFolio,
  }).then(
    (response) => {
      return response;
    },
    (error) => {
      alert("Algo salio mal en la peticion");
      console.error(error);
    }
  );
  return result;
};

export const getEmisioensGeneralesAPI = () => {
  const result = getData(
    "api/Configuracion/Dashboard/EmisionesGenerales",
    {}
  ).then(
    (response) => {
      const { year } = response;
      return { year };
    },
    (error) => {
      alert("Algo salio mal en la peticion");
      console.error(error);
    }
  );
  return result;
};

export const getEmisionesMesDiaAPI = (year, month) => {
  const result = getData("api/Configuracion/Dashboard/EmisionesMesDia", {
    year,
    month,
  }).then(
    (response) => {
      return response;
    },
    (error) => {
      alert("Algo salio mal en la peticion");
      console.error(error);
    }
  );
  return result;
};
